import React, { useState, useEffect, useRef } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import ButtonComponent from '../Button/Button';
import { Times } from '../../../../components/Icon';
import cn from 'classnames';
import styles from './CarouselImageService.module.css';
import { HBox } from '../../../../components/Box';
import { validateImageSrc } from '../../../../modules/Vehicles/helpers';

import env from '../../../../env';
import { AppClientId } from '../../../../modules/Shared/constants';

function ImageServiceCarouselComponent({
  imgURLs,
  imageUrlsSpin,
  onDeleteImg,
  onImageChange,
  onImageClick,
  vehicleId,
  currentImageIndex,
}) {
  const [activeIndex, setActiveIndex] = useState(currentImageIndex || 0);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [storageImage, setStorageImage] = useState(null);
  const thumbnailRefs = useRef([]);
  // const vehicleId = 22029;

  useEffect(() => {
    thumbnailRefs.current = thumbnailRefs.current.slice(0, imgURLs.length);
  }, [imgURLs]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const isShowStorageImage = () => {
    return env.clientId === AppClientId.INDEWAL && storageImage;
  };

  const getValid = callback => {
    validateImageSrc(vehicleId).then(res => {
      if (res) {
        return setStorageImage(true);
      }
    });
    return null;
  };

  const imageClick = (e, imageId, index) => {
    e.stopPropagation();
    e.preventDefault();
    if (index) {
      setActiveIndex(index);
    }
    const images = imageUrlsSpin?.length ? imageUrlsSpin : imgURLs;
    if (onImageChange && images[index]) {
      onImageChange(images[index]);
    }

    if (onImageClick) {
      onImageClick(imageId);
      return;
    }
  };

  const handleSelect = (selectedIndex, e) => {
    const images = imageUrlsSpin?.length ? imageUrlsSpin : imgURLs;
    setActiveIndex(selectedIndex);
    if (onImageChange && images[selectedIndex]) {
      onImageChange(images[selectedIndex]);
    }
  };

  const hasImages = imgURLs.length > 0;

  const renderPlaceholder = () => (
    <div className={cn(styles.placeholder, { [styles.storagePlaceholder]: isShowStorageImage() })}>
      <div
        className={cn(styles.img, { [styles.storageImage]: isShowStorageImage() })}
        style={{
          backgroundImage: isShowStorageImage()
            ? `url('https://vindat.indewal.nl/storage/documents/spin/${vehicleId}/1-7.jpg')`
            : "url('/public/images/placeholder.png')",
        }}
      ></div>
    </div>
  );

  const handleThumbnailClick = (index, event) => {
    event.preventDefault();
    const images = imageUrlsSpin?.length ? imageUrlsSpin : imgURLs;
    setActiveIndex(index);
    if (onImageChange && images[index]) {
      onImageChange(images[index]);
    }
  };

  const renderThumbnails = () => (
    <div className={cn(styles.containerThumbnails, { [styles.containerFlexStart]: imgURLs?.length > 3 })}>
      <div
        className={cn(styles.imageThumbnails, { [styles.containerFlexStart]: imgURLs?.length > 4 })}
        style={{ width: `${imgURLs.length * (100 + 10)}px` }}
      >
        {imgURLs.map((imageUrl, index) => (
          <img
            key={imageUrl.id}
            src={imageUrl.url}
            alt={imageUrl.type}
            className={cn(styles.thumbnail, { [styles.active]: index === activeIndex })}
            onClick={e => handleThumbnailClick(index, e)}
            ref={el => (thumbnailRefs.current[index] = el)}
          />
        ))}
      </div>
    </div>
  );
  const handleDelete = (imageId, event) => {
    onDeleteImg(imageId);
  };

  const renderThumbnailsSpin = () => (
    <div className={cn(styles.containerThumbnails, { [styles.containerFlexStart]: imageUrlsSpin?.length > 3 })}>
      <div
        className={cn(styles.imageThumbnails, { [styles.containerFlexStart]: imageUrlsSpin?.length > 4 })}
        style={{ width: `${imageUrlsSpin.length * (100 + 10)}px` }}
      >
        {imageUrlsSpin.map((imageUrlsSpin, index) => (
          <img
            key={imageUrlsSpin.id}
            src={imageUrlsSpin}
            alt={imageUrlsSpin.type}
            className={cn(styles.thumbnail, { [styles.active]: index === activeIndex })}
            onClick={e => handleThumbnailClick(index, e)}
            ref={el => (thumbnailRefs.current[index] = el)}
          />
        ))}
      </div>
    </div>
  );

  const controlStyles =
    imgURLs.length === 1
      ? `
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    display: none;
  }
`
      : `
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 3rem;
    height: 3rem;
    background-color: #0183D5;
    border-radius: 0.375rem;
  }
`;

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    if (hasImages && onImageChange) {
      onImageChange(imgURLs[activeIndex]);
    }
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (env.clientId === AppClientId.INDEWAL) {
      getValid();
    }
  }, [storageImage]);

  useEffect(() => {
    // if (thumbnailRefs.current[activeIndex]) {
    //   thumbnailRefs.current[activeIndex].scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'nearest',
    //     inline: 'center',
    //   });
    // }
  }, [activeIndex]);

  return (
    <>
      {hasImages ? (
        <>
          <Carousel
            indicators={false}
            className={styles.carousel}
            activeIndex={activeIndex}
            onSelect={handleSelect}
            interval={null}
            controls={imgURLs.length > 1}
          >
            {imgURLs.map((imageUrl, index) => (
              <Carousel.Item
                className={onDeleteImg ? styles.carouselItemPadding : styles.carouselItem}
                key={imageUrl.id}
                onClick={e => imageClick(e, imageUrl.id)}
              >
                <HBox center>
                  <img className={cn('d-block w-100', styles.imgItem)} src={imageUrl.url} alt={imageUrl.type} />
                </HBox>

                {windowWidth >= 375 ? (
                  <div className={styles.buttonDelete}>
                    <ButtonComponent
                      style={'ButtonSoftDelete'}
                      onClick={e => {
                        e.stopPropagation();
                        const confirmDelete = window.confirm("Weet u zeker dat u de foto wilt verwijderen?");
                        if (confirmDelete) {
                          handleDelete(imageUrl.id);
                        }
                      }}
                    >
                    Verwijderen
                    </ButtonComponent>
                  </div>
                ) : (
                  <div
                    className={styles.buttonDelete}
                    onClick={e => {
                      e.stopPropagation();
                      const confirmDelete = window.confirm("Weet u zeker dat u de foto wilt verwijderen?");
                      if (confirmDelete) {
                        handleDelete(imageUrl.id);
                      }
                    }}
                  >
                       Verwijderen
                       </div>
                )}

              </Carousel.Item>
            ))}
          </Carousel>

          {windowWidth >= 768 && renderThumbnails()}

          <style>{controlStyles}</style>
        </>
      ) : isShowStorageImage() ? (
        <>
          <Carousel
            indicators={false}
            className={styles.carousel}
            activeIndex={activeIndex}
            onSelect={handleSelect}
            interval={null}
            controls={imageUrlsSpin.length > 1}
          >
            {imageUrlsSpin.map((url, index) => (
              <Carousel.Item
                className={onDeleteImg ? styles.carouselItemPadding : styles.carouselItem}
                key={index}
                onClick={e => imageClick(e, '', index)}
              >
                <HBox center>
                  <img className={cn('d-block w-100', styles.imgItem)} src={url} alt={`Image ${index + 1}`} />
                </HBox>
                {/* {windowWidth >= 375 ? (
                <div className={styles.buttonDelete}>
                  <ButtonComponent
                    style={'ButtonSoftDelete'}
                    onClick={e => {
                      e.stopPropagation();
                      handleDelete(index);
                    }}
                  >
                    <Times />
                  </ButtonComponent>
                </div>
              ) : (
                <div
                  className={styles.buttonDelete}
                  onClick={e => {
                    e.stopPropagation();
                    handleDelete(index);
                  }}
                >
                  <Times />
                </div>
              )} */}
              </Carousel.Item>
            ))}
          </Carousel>
          {windowWidth >= 768 && renderThumbnailsSpin()}
          <style>{controlStyles}</style>
        </>
      ) : (
        <div className={cn(styles.placeholder, { [styles.storagePlaceholder]: isShowStorageImage() })}>
          <div
            className={cn(styles.img, { [styles.storageImage]: isShowStorageImage() })}
            style={{
              backgroundImage: isShowStorageImage()
                ? `url('https://vindat.indewal.nl/storage/documents/spin/${vehicleId}/1-7.jpg')`
                : "url('/public/images/placeholder.png')",
            }}
          ></div>
        </div>
      )}
    </>
  );
}

export default ImageServiceCarouselComponent;
